import Icon from '../components/Icon';

const TrailPartiallyPaved = Icon(
  'trail-partially-paved',
  <>
    <path d="M12 10.67a1 1 0 1 0 0-2 1 1 0 0 0 0 2M5.25 15.08H.75a.75.75 0 1 1 0-1.5h4.5a.75.75 0 1 1 0 1.5M9.25 15.08h5.52a.75.75 0 1 0 0-1.5H9.25a.75.75 0 1 0 0 1.5M18.75 15.08h4.5a.75.75 0 1 0 0-1.5h-4.5a.75.75 0 1 0 0 1.5M18.5 9.67a1 1 0 1 1-2 0 1 1 0 0 1 2 0M6.5 10.67a1 1 0 1 0 0-2 1 1 0 0 0 0 2M18.5 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M6.5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2M13 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M0 19.75v-1.5h24v1.5zM1 10.67a1 1 0 1 0 0-2 1 1 0 0 0 0 2M1 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2M24 9.67a1 1 0 1 1-2 0 1 1 0 0 1 2 0M24 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
  </>
);

export default TrailPartiallyPaved;
